<template>
    <div :class="styleMain">
      <el-date-picker
        size="small"
        v-model="date"
        type="date"
        placeholder=""
        format="yyyy-MM-dd"
        :default-value="date"
        :clearable="false">
      </el-date-picker>
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionDate',
  props: {
    action: Object
  },
  computed: {
    date: {
      get () { return this.action.date },
      set (value) {
        const dateNew = new Date(value)
        const date = this.action.date
        date.setDate(dateNew.getDate())
        date.setMonth(dateNew.getMonth())
        date.setFullYear(dateNew.getFullYear())
        this.$store.dispatch('Sport/Football/Match/putAction', { id: this.action.id, date: date })
      }
    },

    styleMain () { return ['sportFootballMatchActionDate', this.action.homeAway] }
  }
}
</script>

<style>
.sportFootballMatchActionDate {
  grid-area: date;
}
.sportFootballMatchActionDate .el-date-editor.el-input{
  width: 100%
}
.sportFootballMatchActionDate .el-date-editor.el-input input{
  height:22px;
  font-weight:600;
  font-size:8px;
  color: var(--color-font-grey-light);
  border-radius:16px;
  padding:0;
  text-align: center;
}
.sportFootballMatchActionDate .el-input--small .el-input__icon {
    display:none;
    line-height: 22px;
    font-size: 10px
}
.sportFootballMatchActionDate.home .el-input.is-active .el-input__inner,
.sportFootballMatchActionDate.home .el-input__inner:focus{
  border-color:var(--color-team-home)
}
.sportFootballMatchActionDate.away .el-input.is-active .el-input__inner,
.sportFootballMatchActionDate.away .el-input__inner:focus{
  border-color:var(--color-team-away)
}
</style>
